// Routes owned by the Survey module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const surveyPaths = {
    // Surveys
    surveys: '/surveys',
    // Unreferenced: route commented out in Survey/index.tsx:18 — kept so the pair is restored together.
    surveyCreate: '/surveys/new',
    // Unreferenced: route commented out in Survey/index.tsx:26 — kept so the pair is restored together.
    surveyDetail: '/surveys/:surveyId',
    surveyRecordCreate: '/surveys/records/new',
    surveyRecordDetail: '/surveys/records/:surveyRecordId',
    // Unreferenced: no route; sibling survey routes are commented out — kept with them.
    surveyAnalytics: '/surveys/:surveyId/analytics',
    // Unreferenced: route commented out in Survey/index.tsx:34 — kept so the pair is restored together.
    surveyEdit: '/surveys/:surveyId/edit',
    // Unreferenced: no paths.* caller; /surveys is live, this is its ?tab= deep link.
    surveyAnalyticsV2: '/surveys?tab=analytics-v2',
} as const
